import { Button } from "@/_component/Common";
import AddonPlanDropdown from "../common/plans/AddonPlanDropdown";
import { useLanguageContext } from "@/hooks";
import { renderHeading, renderPrice, renderSubtitle, renderTitle } from "@/utility";

export default function PaymentSummaryCard({planDataList, val, listingType, onRemove, onChoosePlan }) {
    const { language } = useLanguageContext();

    const renderValidity = (item) => {
        const addonPlan = planDataList[item.additionalPlanId];
        if(addonPlan){
            return `Validity: ${addonPlan.tenure} ${language("label.days")}`
        }
    }
    return (
        <div className="card mb-3 kg-border-light">
            <div className="d-flex">
                <div>
                    <img
                        src={val?.thumbnailUrl}
                        alt="listing-img"
                        className="img-fluid rounded-start-2 h-100"
                        style={{ "maxWidth": "12rem", aspectRatio: "5/3" }}
                    />
                </div>
                <div className="card-body">
                    <div className="d-flex justify-content-between flex-fill">
                        <div className="w-100">
                            <h5 className="card-title fw-bold">{renderPrice(val)}</h5>
                            <div className="card-text fw-bold">{renderTitle(val)}</div>
                            <div className="card-text">{renderHeading(val)}</div>
                            <div className="card-text">{renderSubtitle(val)}</div>
                        </div>
                        <div>
                            <Button noSpacing onClick={(e) => onRemove(val?.id, val)}>
                                <i className="bi bi-x-lg fw-bold"></i>
                            </Button>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between align-items-center mt-2">
                        {<AddonPlanDropdown onChoosePlan={() => onChoosePlan(val, listingType)} addonPlans={planDataList} item={val} />}
                        <span className="kg-dark-gray2 fs-7">{renderValidity(val)}</span>
                    </div>
                </div>
            </div>
        </div>
    );
}